var _defs, _circle, _circle2, _circle3, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContigoAppIcono(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 907 969.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #174a7c;\n      }\n\n      .st1 {\n        fill: #1f4e79;\n      }\n\n      .st2 {\n        fill: #d60270;\n      }\n\n      .st3 {\n        fill: #97d700;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 453.6,
    cy: 111.2,
    r: 111.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 125.3,
    cy: 578.1,
    r: 100.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 783.9,
    cy: 578.1,
    r: 100.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,509.1s-2.9-205.7,136.8-324.3c0,0,57.7-50.4,109.1,4.8,46.9,50.4-25.8,114.8-25.8,114.8,0,0-42.8,42.5-71.8,131.1C148.3,435.5,50.7,413.5,0,509.2h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M907,509.1s2.9-205.7-136.8-324.3c0,0-57.7-50.4-109.1,4.8-46.9,50.4,25.8,114.8,25.8,114.8,0,0,42.8,42.5,71.8,131.1,0,0,97.6-22,148.3,73.7h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M235.4,403.8c1.3,21.2,17.2,38.4,38.4,38.4s27.5-8.3,34-20.4c0,0,35.4-88.9,145.3-88.9s150.1,93,150.1,93c7,9.8,18.4,16.3,31.4,16.3,21.2,0,38.4-17.2,38.4-38.4,0,0,5.6-18.8-40.4-69.2s-98.7-80.9-185.7-81.3c-99.6-.6-153.1,57.8-153.1,57.8,0,0-60.4,59.4-58.4,92.8h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M458.8,969.9c-266.9-1.2-393-231.9-393-231.9,0,0,60.3-42.6,132-35.3,0,0,46.4,5.3,89.7,41.6,43.3,36.4,75.8,46.3,88.3,52.4s31.6,23,23.4,52-39.8,23.4-45.9,22.1c-6.1-1.3-70.6-23-93.5-40.7,0,0-4.6,2.5.9,7.4,3.8,3.4,38.1,28.1,71.4,41,32.9,12.7,70.3,23.1,124.9,23.1h-4.5c54.6,0,92-10.5,124.9-23.1,33.3-12.8,67.5-37.5,71.4-41,5.5-4.9.9-7.4.9-7.4-23,17.8-87.5,39.4-93.5,40.7s-37.7,6.9-45.9-22.1,10.8-45.9,23.4-52,45-16,88.3-52.4,89.7-41.6,89.7-41.6c71.7-7.3,132,35.3,132,35.3,0,0-126.1,230.6-393,231.8h8.3-.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContigoAppIcono);
export default __webpack_public_path__ + "static/media/contigo_App_icono.ab3d421b8ae61a5183784ec7280e5369.svg";
export { ForwardRef as ReactComponent };